module.exports = __webpack_public_path__ + "static/media/14.ddd854d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/rhand/14.png
// module id = 931
// module chunks = 0